import React, { useEffect, useState } from "react";
import { Checkbox, Form, Select } from "antd";

import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/Button/Button";
import {
  assignDataElementsForm,
  dataElementListAction,
  selectedDataElementsList,
} from "../../actions/leader";
import UserLeaderListing from "../../components/Comman/DropdownsListing/UserLeaderListing";
import { UserOrganizationListAction } from "../../actions/user";
import organizatonLogo from "../../../src/images/icon/organization.png";
import {
  capitalizeFirstLetter,
  elementInterval,
  formatToCST,
} from "../../utils/comman";

const AssignElements = () => {
  const { Option } = Select;
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [selectedOrgId, setSelectedOrgId] = useState<number | null>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const userData = useSelector((state: any) => state?.Auth?.user);
  const userRoleId = userData?.user?.id;
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [originallyAssignedElements, setOriginallyAssignedElements] = useState<
    number[]
  >([]);
  // State to track all selected elements across pages
  const [allSelectedElements, setAllSelectedElements] = useState<{
    [key: number]: boolean;
  }>({});

  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
    totalPages: 0,
  });

  const [orgPagination, setOrgPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  });
  // Changed from single selection to multiple selection array
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
  const [form] = Form.useForm();

  // Function to handle checkbox change for each row
  const handleCheckboxChange = (recordId) => {
    // Update the all selected elements state
    setAllSelectedElements((prev) => ({
      ...prev,
      [recordId]: !prev[recordId],
    }));

    // Update selected row keys for the current page
    setSelectedRowKeys((prev) => {
      if (prev.includes(recordId)) {
        return prev.filter((id) => id !== recordId);
      } else {
        return [...prev, recordId];
      }
    });
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    // Reset selected elements when user changes
    setSelectedRowKeys([]);
    setAllSelectedElements({});
    setOriginallyAssignedElements([]);
  };

  // Function to handle submission of selected data elements
  const handleSubmit = () => {
    // Combine originally assigned elements with newly selected elements
    // Exclude any originally assigned elements that have been unchecked
    const dataElementsToAssign = [
      // Keep originally assigned elements that are still checked
      ...originallyAssignedElements.filter(
        (originalId) => allSelectedElements[originalId] !== false
      ),
      // Add newly selected elements that were not originally assigned
      ...Object.keys(allSelectedElements)
        .filter(
          (selectedId) =>
            allSelectedElements[Number(selectedId)] === true &&
            !originallyAssignedElements?.includes(Number(selectedId))
        )
        .map(Number),
    ];

    const payload = {
      dataElements: dataElementsToAssign,
      userId: selectedUserId,
      organizationId: selectedOrgId,
    };

    dispatch(
      assignDataElementsForm(payload, (resp: any) => {
        if (resp?.status == 200 || resp?.status === 201) {
          // Reset form and all related states

          getPreSelectedDataElements();
          // Refresh the table data
          fetchAssignElementsList({
            page: pagination.current,
            limit: pagination.pageSize,
          });
        }
      })
    );
  };

  const fetchOrganizationList = (params = {}) => {
    setLoading(true);
    const requestParams = {
      ...params,
      ...(sortConfig.field && sortConfig.order
        ? {
            sort: sortConfig.field,
            order: sortConfig.order,
          }
        : {}),
    };
    dispatch(
      UserOrganizationListAction(requestParams, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setOrganizations(resp.data || []);
          setOrgPagination({
            ...orgPagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchOrganizationList({
      page: orgPagination.current || 1,
      limit: orgPagination.pageSize || 10,
    });
  }, [sortConfig.field, handleRefresh]);

  // Handle onPopupScroll event for the Select component
  const handleSelectScroll = (e: React.UIEvent<HTMLDivElement>) => {
    // Check if user has scrolled to the bottom
    const { target } = e;
    if (
      !loading &&
      target instanceof HTMLElement &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 &&
      orgPagination.current < orgPagination.totalPages
    ) {
      // Load next page
      const nextPage = orgPagination.current + 1;
      fetchOrganizationList({
        page: nextPage,
        limit: orgPagination.pageSize,
      });
    }
  };

  // Fetch assign elements list
  const fetchAssignElementsList = (params = {}) => {
    setLoading(true);
    dispatch(
      dataElementListAction({ params, id: selectedOrgId }, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          // Merge pre-assigned elements with current table data selection
          const currentPageElementIds =
            resp?.data?.map((item) => item.id) || [];
          const preAssignedOnCurrentPage = originallyAssignedElements.filter(
            (id) => currentPageElementIds.includes(id)
          );
          setTableData(resp?.data || []);
          // Set selected row keys to include originally assigned elements on current page
          setSelectedRowKeys(preAssignedOnCurrentPage);
          setPagination({
            ...pagination,
            total: resp?.pagination?.totalItems,
            current: resp?.pagination?.currentPage,
            pageSize: resp?.pagination?.pageSize,
            totalPages: resp?.pagination?.totalPages,
          });
        }
      })
    );
  };

  useEffect(() => {
    if (
      selectedOrgId &&
      selectedUserId
      // && originallyAssignedElements?.length > 0
    ) {
      fetchAssignElementsList({
        page: pagination.current,
        limit: pagination.pageSize,
      });
    }
  }, [
    sortConfig.field,
    sortConfig.order,
    handleRefresh,
    selectedOrgId,
    selectedUserId,
    originallyAssignedElements,
  ]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };

    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);

    fetchAssignElementsList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const getPreSelectedDataElements = () => {
    dispatch(
      selectedDataElementsList(
        { organizationId: selectedOrgId, userId: selectedUserId },
        (response) => {
          if (response?.status === 200) {
            // Extract IDs of pre-assigned elements
            const preAssignedElementIds = response?.data?.map(
              (element) => element.id
            );

            // Create an object to track originally assigned elements
            const originalAssignedMap = preAssignedElementIds.reduce(
              (acc, id) => {
                acc[id] = true;
                return acc;
              },
              {}
            );

            // Update states
            setOriginallyAssignedElements(preAssignedElementIds);
            setAllSelectedElements(originalAssignedMap);
          }
        }
      )
    );
  };

  useEffect(() => {
    if (!selectedOrgId || !selectedUserId) return;
    getPreSelectedDataElements();
  }, [selectedOrgId, selectedUserId]);

  const columns = [
    {
      title: "",
      dataIndex: "select",
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.id)}
          onChange={() => handleCheckboxChange(record.id)}
        />
      ),
    },
    {
      title: "Org",
      dataIndex: "organizationName",
      key: "orgName",
      render: (_, data) => {
        return data?.assignment[0]?.organization?.name;
      },
      // sorter: true,
    },
    {
      title: "Elements Name",
      dataIndex: "DataElements_Name",
      key: "DataElements_Name",
      sorter: true,
    },
    {
      title: "Elements Description",
      dataIndex: "DataElements_Description",
      key: "DataElements_Description",
    },
    {
      title: "Assigned To",
      key: "assignedTo",
      render: (_, record) => {
        const assignedUser = record?.orgElementsLinks?.[0]?.user;
        return assignedUser ? assignedUser.email : "—";
      },
    },
    {
      title: "Is Budgeted",
      dataIndex: "DataElements_IsBudgeted",
      key: "DataElements_IsBudgeted",
      render: (record) => (record ? "Yes" : "No"),
    },
    {
      title: "Data Type",
      dataIndex: "DataElements_DataType",
      key: "DataElements_DataType",
      render: (text: string) => capitalizeFirstLetter(text) || "-",
    },
    {
      title: "Interval",
      dataIndex: "interval",
      key: "interval",
      render: (_, record) => record?.interval?.Interval_Name
    },

    {
      title: "Last Updated ",
      dataIndex: "DataElements_StartingDueDate",
      key: "DataElements_StartingDueDate",
      render: (data) => (data ? formatToCST(data) : "-"),
    },
    {
      title: "Last Updated By",
      dataIndex: "DataElements_LastUpdatedBy",
      key: "DataElements_LastUpdatedBy",
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Assign Data Elements
        </h1>
      </div>
      <Form
        form={form}
        layout="vertical"
        // onValuesChange={handleFormValuesChange}
      >
        <div className="flex justify-between bg-primary p-[15px] rounded-[10px] items-center">
          <div className="flex gap-[45px] items-center">
            <div className="select-col flex gap-[10px] items-center">
              <p className="info-col">Select Organization</p>
              {/* <div className="ant-picker ant-picker-outlined css-dev-only-do-not-override-240cud range-datepicker-col"> */}
              <div className="mb-none">
                <Form.Item
                  name="organizationId"
                  rules={[
                    { required: true, message: "Please select a organization" },
                  ]}
                >
                  <Select
                    // open={true}
                    placeholder="Select Organization"
                    className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
                    onPopupScroll={handleSelectScroll}
                    loading={loading}
                    notFoundContent={loading ? "Loading..." : "No data found"}
                    listHeight={200}
                    allowClear
                    showSearch
                    onChange={(value) => setSelectedOrgId(value)}
                  >
                    {organizations?.map((org) => (
                      <Option
                        key={org?.id}
                        value={org?.id}
                        style={{
                          backgroundColor: "#013351",
                          border: "none",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "2px",
                            width: "auto",
                          }}
                        >
                          <img
                            src={org?.logo ? org?.logo : organizatonLogo}
                            alt={org?.name}
                            style={{
                              width: 28,
                              marginRight: 5,
                              objectFit: "cover",
                              borderRadius: "1px",
                            }}
                          />
                          {/* <Avatar
                            src={org?.logo ? org?.logo : undefined} // Dynamically set image
                            icon={!org?.logo && organizatonLogo} // Show icon if no image
                            className="p-[3px] bg-primary rounded-[10px] object-cover"
                            style={{
                              // width: 28,
                              marginRight: 5,
                              objectFit: "contain",
                              borderRadius: "1px",
                            }}
                          /> */}

                          {org?.name}
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div className="select-col flex gap-[10px] items-center">
              <p className="info-col">Select User Name:</p>
              {/* <div className="ant-picker ant-picker-outlined css-dev-only-do-not-override-240cud range-datepicker-col"> */}

              <UserLeaderListing
                leaderId={userRoleId}
                dataToSet={{}}
                onSelect={handleUserSelect}
                selectedOrgId={selectedOrgId}
                type={"dataElementAssignment"}
              />
              {/* {selectedUserId && <p>Selected User ID: {selectedUserId}</p>} */}
            </div>
          </div>
        </div>
      </Form>
      <div className="table-col mt-5">
        <DataTable
          columns={columns}
          data={tableData}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>

      {/* Added submit button */}
      <div className="flex justify-center mt-5">
        <Button
          buttonText="Assign"
          onClick={handleSubmit}
          width="250px"
          // disabled={selectedRowKeys.length === 0 || !selectedUserId}
        />
      </div>
    </div>
  );
};

export default AssignElements;
